import { useFormik } from "formik";
import Button from "../../../components/buttons/button";
import * as yup from "yup";
import EditIcon from "../../../icons/editIcon";
import DeleteIcon from "../../../icons/deleteIcon";
import { useState } from "react";
import Popup from "../../../components/popups/popup";
import { createPortal } from "react-dom";
import EditLeave from "./editLeave";
const LeaveSetup = ({ t, setOpen }) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [selected, setSelected] = useState("");

  const validationSchema = yup.object({});

  const formik = useFormik({
    initialValues: {
      days: [
        { name: "عيد الفطر", end: "13/04/2023", start: "10/04/2023" },
        { name: "عيد الأضحى", end: "20/06/2023", start: "17/06/2023" },
        { name: "اليوم الوطني", end: "23/09/2023", start: "23/09/2023" },
      ],
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
      setOpen(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      {formik.values.days.length > 0
        ? formik.values.days.map((d, i) => {
            return (
              <div
                key={i}
                className="flex items-center justify-between px-1 py-2 border-b"
              >
                <div>
                  <h4 className="mb-2 font-bold text-primary">{d.name}</h4>
                  <p>
                    {d.start} - {d.end}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      setOpenEdit(true);
                      setSelected({ d, i });
                    }}
                  >
                    <EditIcon fill={"#d1a855 "} />
                  </span>
                  <DeleteIcon />
                </div>
              </div>
            );
          })
        : ""}

      <div className="flex items-center justify-end gap-3">
        <Button
          className={"bg-primary justify-center w-[130px] text-[#1F384C] text-sm"}
        >
          {t("confirm")}
        </Button>
        <Button
          className={"border border-[#C42E27] text-[#C42E27] text-sm"}
          type="button"
          onClick={() => setOpen(false)}
        >
          {t("cancel")}
        </Button>
      </div>
      {openEdit && (
        <>
          {createPortal(
            <Popup open={openEdit} setOpen={setOpenEdit} header={selected?.d?.name}>
              <EditLeave
                formik={formik}
                t={t}
                selected={selected}
                setOpen={setOpenEdit}
              />
            </Popup>,
            document.body
          )}
        </>
      )}
    </form>
  );
};

export default LeaveSetup;
